<script setup lang="ts">
import { computed } from 'vue'

import Rating from '../Rating.vue'

import type { RatingSize } from '../Rating.vue'

const props = withDefaults(defineProps<{
  title?: string
  size?: RatingSize
  rating?: number
  hideBorder?: boolean
  uniqueProductId?: string
}>(), {
  hideBorder: false
})

const productRatingStyles = computed(() => ({
  'bx-product__rating': true,
  'bx-product__rating--border-none': props.hideBorder,
  'bx-product__rating--no': !props.rating
}))
</script>

<template>
  <div :class="productRatingStyles"
       :data-product-unique-id="uniqueProductId"
       data-tc="product-rating">
    <div class="bx-rating__wrapper">
      <span v-if="title"
            class="bx-product__title bx-product__title--rating">{{ title }}</span>
      <Rating :average="rating"
              :average-fraction-digits="1"
              quantity="/5"
              :show-average="true"
              :size="size"
              :title="`Unsere Bewertung: ${rating} / 5`" />
    </div>
  </div>
</template>
